import { useAuth } from '../lib/auth';

export function SettingsPage() {
  const { user, organization } = useAuth();

  return (
    <div className="max-w-3xl space-y-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-sm text-ink-500 dark:text-ink-400">
          Workspace and account information.
        </p>
      </header>

      <section className="card p-5 space-y-3">
        <h2 className="font-semibold">Organization</h2>
        <Row label="Name" value={organization?.name} />
        <Row label="Slug" value={organization?.slug} />
        <Row label="Plan" value={organization?.plan} />
      </section>

      <section className="card p-5 space-y-3">
        <h2 className="font-semibold">Profile</h2>
        <Row label="Email" value={user?.email} />
        <Row label="Name" value={user?.name ?? '—'} />
        <Row label="Role" value={user?.role} />
        <Row label="Status" value={user?.status} />
      </section>

      <section className="card p-5 space-y-3">
        <h2 className="font-semibold">Tips</h2>
        <ul className="space-y-2 text-sm text-ink-600 dark:text-ink-300 list-disc pl-5">
          <li>API keys can be generated by an organization owner via the API.</li>
          <li>Need to delete your account? Contact an administrator.</li>
          <li>
            For password resets, ask your administrator to issue a new password from the admin
            console.
          </li>
        </ul>
      </section>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string | null | undefined }) {
  return (
    <div className="flex items-baseline justify-between gap-3 text-sm">
      <span className="text-ink-500 dark:text-ink-400">{label}</span>
      <span className="font-medium">{value ?? '—'}</span>
    </div>
  );
}
